<template>
  <div class="typewriter">
    <div v-for="(line, index) in textToType"
         :class="'typewriter__line line--' + index " style="display: none;"
         :key="'line' + index"
         ref="line">
      <span v-for="(word, index) in line"
            :class="'typewriter__word word--' + index " :key="'word' + index"
            ref="word">
            <span v-for="(char, index) in word"
              :class="'typewriter__char char--' + index " style="opacity:0"
              :key="'char' + index"
              ref="char">{{ char }}</span>
      </span>
    </div>
  </div>
</template>


<script>
export default {
  name: 'Typewriter',
  props: {
    text: {
      type: String,
      required: true,
    },
    speed: {
      type: Number,
      default: 300,
    },
    preTypeDelay: {
      type: Number,
      default: 70,
      validator: value => value >= 0,
    },
  },
  data() {
    return {
      textToType: [],
      linesCounter: 0,
      charCounter: 0,
    };
  },
  created() {
    this.textToType = this.text
      .split('<br>')
      .map(line => line.split(' ').map(word => word.split('')));
  },
  mounted() {
    setTimeout(() => this.startTyping(this.$refs.line[0]), 500);
  },
  methods: {
    startTyping(line) {
      this.linesCounter += 1;

      this.$emit('startTyping');

      line.style.display = 'flex';
      this.$emit('typed-line');

      const chars = Array.from(line.querySelectorAll('.typewriter__char'));

      const interval = setInterval(() => {
        if (chars.length) {
          this.type(chars.shift());
        } else {
          clearInterval(interval);
          this.nextLine();
        }
      }, this.speed);
    },
    type(char) {
      this.$emit('typed-char', char);
      char.removeAttribute('style');
    },
    nextLine() {
      if (this.linesCounter < this.$refs.line.length) {
        this.startTyping(this.$refs.line[this.linesCounter]);
      } else {
        this.$emit('complete');
      }
    },
  },
};
</script>


<style lang="scss">
.typewriter {
  &__line {
    display: flex;
    justify-content: flex-end;
    flex-wrap: wrap;
  }

  &__word {
    margin-left: 0.2em;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Typewriter.vue